const df = n => n < 10 ? `0${n}` : n;
export const getDate = d => `${df(d.getDate())}.${df(d.getMonth() + 1)}.${d.getFullYear().toString().slice(-2)}`;
export const getDateTime = value => value ? `${getDate(value)}, ${df(value.getHours())}:${df(value.getMinutes())}` : ''

export default ({ value, ...props }) => (<span {...props}>{getDateTime(value)}</span>);
